import * as React from 'react';

function ClosureWarningIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={78} height={78} viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.0005 9.75C22.8462 9.75 9.75049 22.8457 9.75049 39C9.75049 55.1543 22.8462 68.25 39.0005 68.25C55.1548 68.25 68.2505 55.1543 68.2505 39C68.2505 22.8457 55.1548 9.75 39.0005 9.75ZM3.25049 39C3.25049 19.2558 19.2563 3.25 39.0005 3.25C58.7447 3.25 74.7505 19.2558 74.7505 39C74.7505 58.7442 58.7447 74.75 39.0005 74.75C19.2563 74.75 3.25049 58.7442 3.25049 39Z"
        fill="currentColor"
      />
      <path
        d="M39.0497 17.6914C41.9068 17.6914 43.3353 20.2887 43.3353 25.4834C43.3353 28.3005 42.9557 32.2565 42.1965 37.3512C41.4373 42.446 40.8179 45.5029 40.3384 46.5218C40.0187 47.2211 39.5892 47.5708 39.0497 47.5708C38.4503 47.5708 37.9908 47.2611 37.6711 46.6417C37.2316 45.8625 36.6222 43.0054 35.843 38.0705C35.0638 33.1356 34.6542 28.9399 34.6143 25.4834C34.6143 20.2887 36.0927 17.6914 39.0497 17.6914ZM38.9598 51.4368C40.1586 51.4368 41.2275 51.9063 42.1665 52.8454C43.1056 53.7844 43.5751 54.8533 43.5751 56.0521C43.5751 57.2708 43.1155 58.3397 42.1965 59.2588C41.2774 60.1778 40.1985 60.6374 38.9598 60.6374C37.7011 60.6374 36.6222 60.1878 35.7231 59.2887C34.8241 58.3697 34.3745 57.2908 34.3745 56.0521C34.3745 54.8133 34.834 53.7344 35.7531 52.8154C36.6722 51.8963 37.7411 51.4368 38.9598 51.4368Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoClosureWarningIcon = React.memo(ClosureWarningIcon);
export default MemoClosureWarningIcon;
